import MosaiqClient from "../clients/MosaiqClient";
import {
  BestSellers,
  Featured,
  MarketingCategory,
  MarketingHome,
  Seo,
  Sliders,
  Universe,
} from "@/models/marketingHome";
import { AxiosRequestConfig } from "axios";

export default class MarketingService {
  static of(): MarketingService {
    return new MarketingService();
  }

  getFaq() {
    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        attrRef: "sku",
      },
    };
    return MosaiqClient.of().get("afs_marketing_other/faq", axiosRequestConfig).then(
      (data) => {
        return data.values;
      },
      err => {
        throw err;
      },
    );
  }

  getCategory(categoryPath) {
    /*
    *  "attrId":"marketing_landing_category",
            "attrValue": "/ART DE VIVRE/ARTS DE VIVRE/",
            "section": "...",
            * */
    const params = {
      attrId: "marketing_landing_category",
      attrValue: categoryPath,
      categoryUp: false,
    };

    return MosaiqClient.of().post("afs_marketing_landing/findOne", params).then(
      (data) => {
        return MarketingCategory.of(data.values);
      },
      err => {
        throw err;
      },
    );
  }

  getHomePage(section) {
    /*
    marketing_homepage_slider
    marketing_homepage_bestsellers
    marketing_homepage_featured
    marketing_homepage_universe
    marketing_homepage_seo
    */

    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        section: section,
        attrRef: "sku",
      },
    };

    return MosaiqClient.of().get("afs_marketing_other/homepage", axiosRequestConfig).then(
      (data) => {

        return MarketingHome.of(data.values);
      },
      err => {
        throw err;
      },
    );
  }

  getHomeFeatured() {
    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        section: "marketing_homepage_featured",
        attrRef: "sku",
      },
    };
    return MosaiqClient.of().get("afs_marketing_other/homepage", axiosRequestConfig).then(
      (data) => {
        return Featured.of(data.values);
      },
      err => {
        throw err;
      },
    );
  }

  getHomeSlider() {
    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        section: "marketing_homepage_slider",
        attrRef: "sku",
      },
    };
    return MosaiqClient.of().get("afs_marketing_other/homepage", axiosRequestConfig).then(
      (data) => {
        return Sliders.of(data.values);
      },
      err => {
        throw err;
      },
    );
  }

  getBestSellers() {
    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        section: "marketing_homepage_bestsellers",
        attrRef: "sku",
        replaceIdBy: "sku",
      },
    };
    return MosaiqClient.of().get("afs_marketing_other/homepage", axiosRequestConfig).then(
      (data) => {
        return BestSellers.of(data.values);
      },
      err => {
        throw err;
      },
    );
  }

  getUniverse() {
    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        section: "marketing_homepage_universe",
        attrRef: "sku",
      },
    };
    return MosaiqClient.of().get("afs_marketing_other/homepage", axiosRequestConfig).then(
      (data) => {
        return Universe.of(data.values);
      },
      err => {
        throw err;
      },
    );
  }

  getHomeSeo() {
    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        section: "marketing_homepage_seo",
        attrRef: "sku",
      },
    };
    return MosaiqClient.of().get("afs_marketing_other/homepage", axiosRequestConfig).then(
      (data) => {
        return Seo.of(data.values);
      },
      err => {
        throw err;
      },
    );
  }

  getDelivery() {
    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        attrRef: "sku",
      },
    };
    return MosaiqClient.of().get("afs_marketing_other/delivery", axiosRequestConfig).then(
      (data) => {
        return data.values;
      },
      err => {
        throw err;
      },
    );
  }

  getExchangeAndReturn() {
    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        attrRef: "sku",
      },
    };
    return MosaiqClient.of().get("afs_marketing_other/exchange-return", axiosRequestConfig).then(
      (data) => {
        return data.values;
      },
      err => {
        throw err;
      },
    );
  }

  getCGV() { /* TODO */
  }

}